// *******************************************************************************
// Parallax Module
// *******************************************************************************

const parallaxModules = document.querySelectorAll('.parallax-module');

if (parallaxModules.length > 0) {
  const parallaxController = new ScrollMagic.Controller();

  const initParallaxScrollMagic = () => {
    const isMobile = windowWidth() < breakpointMd;
    parallaxModules.forEach((element) => {
      const parentElem = element.closest('.sc-parallax-module');
      const stickyContent = parentElem.querySelector('.parallax-module__inner');
      const triggerPoint = parentElem.querySelector('.parallax-module__sticky');
      const wrapperEle = parentElem.querySelector('.parallax-module__body');
      const items = wrapperEle.querySelectorAll('.gallery-card');
      const totalScrollDuration = wrapperEle.clientHeight - stickyContent.clientHeight;

      // Pin the sticky section
      new ScrollMagic.Scene({
        triggerElement: triggerPoint,
        duration: totalScrollDuration,
        triggerHook: 0,
      })
        .setPin(stickyContent)
        // .addIndicators({ name: 'Sticky Content' }) // enable for debugging
        .addTo(parallaxController);

      // Independent parallax to each gallery card
      items.forEach((image, imgIndex) => {
        const moveAmount = isMobile ? 5 : 20 + imgIndex * 8;
        const moveY = `${(imgIndex % 2 === 0 ? -1 : 1) * moveAmount}%`;

        const imageTween = gsap.to(image, {
          y: moveY,
          ease: 'power3.inOut',
        });

        const depthMultiplier = 1.1 + imgIndex * 0.15;

        new ScrollMagic.Scene({
          triggerElement: triggerPoint,
          triggerHook: 0,
          duration: totalScrollDuration * depthMultiplier,
        })
          .setTween(imageTween)
          // .addIndicators({ name: `Card ${imgIndex}` })
          .addTo(parallaxController);
      });
    });
  };

  initParallaxScrollMagic();
}
